module.exports = __webpack_public_path__ + "static/media/Angel-Aura.fa630a3a.png";